import React from 'react';
import PropTypes from 'prop-types';

import Column from '@Theme/hijunior/components/Column/Column';
import Container from '@Theme/hijunior/components/Container/Container';
import Row from '@Theme/hijunior/components/Row/Row';
import Text from '@Theme/hijunior/components/Text/Text';
import CategoriesItem from './CategoriesItem';
import Icon from '@Theme/hijunior/components/Icon/Icon';

import * as styles from './Categories.module.scss';

const propTypes = {
  /**
   * Module heading
   */
  heading: PropTypes.string,

  /**
   * Module description
   */
  description: PropTypes.string,

  /**
   * icon
   */
  icon: PropTypes.string,

  /**
   * Icon size
   */
  flagIconSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }),

  /**
   * Array of item properties
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      iconSize: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number
      }),
      heading: PropTypes.string,
      articles: PropTypes.string,
      url: PropTypes.string
    })
  )
};

/**
 * Categories Module
 */
const Categories = ({
  heading,
  description,
  items,
  icon,
  flagIconSize
}) => (
  <section className={styles.root}>
    <Container>
      <Icon name={icon} classname={styles.rootIcon} size={flagIconSize}/>
      <Text as='h2' contents={heading} classname={styles.rootHeading}/>
      <Text contents={description} classname={styles.rootDescription}/>

      <Row classname={styles.rootRow}>
        {items?.map(({
          title,
          icon,
          iconSize,
          description,
          url
        }, index) => (
          <Column xs={4} md={4} key={index} classname={styles.rootCol}>
            <CategoriesItem
              icon={icon}
              title={title}
              description={description}
              iconSize={iconSize}
              url={url}/>
          </Column>
        ))}
      </Row>
    </Container>
  </section>
);

Categories.propTypes = propTypes;

export default Categories;
